
import { Component, Prop, Vue, } from 'vue-property-decorator';
import ProgressSteps from '~/components/progress-steps/progress-steps.vue';

// const progressStepsLabels = [
// 	'Moving details',
// 	'Your details',
// 	'Payment details',
// 	'Bank details',
// 	'Check details',
// 	'Login details',
// ];

@Component({
	components: {
		ProgressSteps,
	},
})
export default class MoveInProgressSteps extends Vue {
	@Prop({
		type: Number,
		required: true,
	})
	currentStep!: number;

	// @Prop({
	// 	type: Boolean,
	// 	required: false,
	// })
	// isMoveInForcefullySucceeded!: boolean;

	@Prop({
		type: Array,
		required: false,
	})
	progressStepsLabels!: [];

	// progressStepsLabels = progressStepsLabels;

	// beforeUpdate() {
	// 	if (this.isMoveInForcefullySucceeded) {
	// 		progressStepsLabels.pop();
	// 		progressStepsLabels.push('Confirmation');
	// 	}
	// }
}
